import { createApiReducer } from 'infrastructure/api';

export const initialState = {};

const handlers = {
  'app/user/GET_USER_INFO': (state, payload) => payload || null,
};

const apiReducer = createApiReducer(handlers, initialState);

const currentUserReducer = (state = initialState, action) => {
  if (action.type === 'CLEAR_AUTH') {
    return {};
  }

  return apiReducer(state, action);
};

export default currentUserReducer;
